import React from 'react';
import BeneficiryBase from '../../components/beneficiary/BeneficiaryBase';
import TrusteeBase from '../../components/trustee/TrusteeBase';
import UserBase from '../../components/user/UserBase';
import { getUser } from '../../services/user-service';
import { WritingcenterDiaryPopup } from './WritingcenterDiaryPopup';
import OrganizationBase from "../organization/OrganizationBase";


function Writingcenterdiaryroute() {
    let role = getUser().role;
    if (role === "BENEFICIARY") {
         return (
            <BeneficiryBase>
                <WritingcenterDiaryPopup />
            </BeneficiryBase>
        )
    }
//     else if (role === "USER") {
//     else if (role === "USER" || (role === "ORG_USER" && getUser().accountType === "primary")) {
       else if (
               role === "USER" ||
               (role === "ORG_USER" && (getUser().accountType === "primary" || getUser().accountType === "secondary"))
           ) {
        return (
            <UserBase>
                <WritingcenterDiaryPopup />
            </UserBase>
        )
    }
    else if (role === "TRUSTEE") {
        return (
            <TrusteeBase>
                <WritingcenterDiaryPopup />
            </TrusteeBase>
        )
    }
else if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
        return (
      <OrganizationBase>
                <WritingcenterDiaryPopup />
      </OrganizationBase>
        );
    }
}
export default Writingcenterdiaryroute;